import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';
import { CountrySelect } from '../../website-js/CountrySelect';
import { HttpClient } from '@angular/common/http';
// import { TagService } from 'src/app/tag.service';
import { stateOptions } from '../,,/../../website-js/stateOptions';

@Component({
  selector: 'app-company-howtobuy-nested',
  templateUrl: './company-howtobuy-nested.component.html',
  styleUrls: ['./company-howtobuy-nested.component.scss']
})
export class CompanyHowtobuyNestedComponent extends CountrySelect implements OnInit, OnDestroy {

  stateOptions = stateOptions;

  constructor(
    public _httpService: HttpService,
    _http: HttpClient,
    ) {
      super(_http);
  }

  ngOnInit(): void {
  }


  locate(): void {
    this.subs.push(this._httpService.getCountry().subscribe((data) => {
      // console.log(data);
      this.countries = data.result.country;
    }));
    this.getReps();
    // const element1 = document.getElementById('countryselect');
    // element1.classList.add('show');
  }
  ngOnDestroy(): void {
    this.subs.forEach((sub) => {
        sub.unsubscribe();
    });
  }

}
